export const getLoginUserData = ()=>{
    return JSON.parse(sessionStorage.getItem("userTenant"));
}